import React from 'react';
import PropTypes from 'prop-types';

import Avatar from '../../nucleus/avatar/avatar';
import './admin-voucher-submission-table.scss';

const AdminVoucherSubmissionTable = ({ history }) => (
  <div className="admin-voucher-history-card">
    <div className="results-table">
      <div className="table-header">
        <div className="header-cell">SUBMITTED BY</div>
        <div className="header-cell">SUBMITTED DATE</div>
        <div className="header-cell">EARLY INVOICE</div>
        <div className="header-cell">SUBMISSION STATUS</div>
        <div className="header-cell">EMAIL RECIPIENTS</div>
      </div>
      {history && history.length > 0 ? history.map((entry, idx) => (
        <div className="admin-table-row" key={idx}>
          <div className="admin-cell">
            {entry.submitted_by ? (
              <div className="admin-created-by-cell">
                <span className="admin-cell-bold">{entry.submitted_by.first_name || ''} {entry.submitted_by.last_name || ''}</span>
                <div className="lead-producer-email-text">{entry.submitted_by.email || entry.submitted_by.employee_work_email || '--'}</div>
              </div>
            ) : '--'}
          </div>
          <div className="admin-cell">{entry.submission_date ? <span>{entry.submission_date}</span> : '--'}</div>
          <div className="admin-cell">{entry.is_early_invoice ? 'Yes' : 'No'}</div>
          <div className="admin-cell">{idx === 0 && entry.submission_status ? <span className="status-chip">{entry.submission_status}</span> : '-'}</div>
          <div className="admin-cell email-recipients-cell">
            {Array.isArray(entry.email_recipients) && entry.email_recipients.length > 0 ? (
              <span className="email-recipients-container">
                {entry.email_recipients.map((recipient, i) => {
                  let firstName = '', lastName = '', avatarUrl = '', nameOrEmail = '';
                  if (typeof recipient === 'object' && recipient) {
                    firstName = recipient.first_name || '';
                    lastName = recipient.last_name || '';
                    avatarUrl = recipient.avatar || recipient.avatar_url || '';
                    nameOrEmail = recipient.name || recipient.email || recipient.email_address || '';
                  } else if (typeof recipient === 'string') {
                    nameOrEmail = recipient;
                  }
                  if (firstName || lastName || avatarUrl || nameOrEmail) {
                    const displayFirstName = firstName || nameOrEmail.split('@')[0] || nameOrEmail.split(/\s+/)[0] || '';
                    const displayLastName = lastName || (nameOrEmail.includes(' ') ? nameOrEmail.split(/\s+/).slice(1).join(' ') : '');
                    const fullDisplayName = `${displayFirstName} ${displayLastName}`.trim() || nameOrEmail || 'Unknown User';
                    
                    return (
                      <span className="avatar-wrapper" key={i} title={fullDisplayName}>
                        <Avatar
                          image={avatarUrl}
                          firstName={displayFirstName}
                          lastName={displayLastName}
                          sizing="md"
                          enableHover={false}
                          hoverAlign="center"
                        />
                        <span className="custom-hover-tooltip">{fullDisplayName}</span>
                      </span>
                    );
                  } else {
                    // fallback to initials chip
                    let initials = '';
                    if (nameOrEmail) {
                      const parts = nameOrEmail.split(/\s+|\./).filter(Boolean);
                      if (parts.length === 1 && parts[0].includes('@')) {
                        initials = parts[0].slice(0,2).toUpperCase();
                      } else {
                        initials = parts.map(p => p[0]).join('').slice(0,2).toUpperCase();
                      }
                    }
                    return (
                      <span
                        key={i}
                        title={nameOrEmail}
                        className="initials-chip"
                      >
                        {initials || '--'}
                      </span>
                    );
                  }
                })}
              </span>
            ) : '--'}
          </div>
        </div>
      )) : (
        <div className="admin-table-row">
          <div className="admin-cell" style={{gridColumn: '1 / -1'}}>No submission history available.</div>
        </div>
      )}
    </div>
  </div>
);

AdminVoucherSubmissionTable.propTypes = {
  history: PropTypes.arrayOf(PropTypes.shape({
    submitted_by: PropTypes.object,
    submission_date: PropTypes.string,
    is_early_invoice: PropTypes.bool,
    submission_status: PropTypes.string,
    email_recipients: PropTypes.array,
    unique_id: PropTypes.string,
  })).isRequired,
};

export default AdminVoucherSubmissionTable;
